module.exports = __webpack_public_path__ + "img/basque-country.ba455734.svg";